import {Assets, Container, Graphics, Sprite, Texture} from "pixi.js";

import { ImageDrawable } from "./image.pixi";
import {FilesService} from "../../../../services/files/files.service";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {PixiObject} from "../primitives/pixi-object";
import {Subscription} from "rxjs";
import {selectUserById} from "../../../../state/users/users.selector";
import {User} from "../../../../auth/primitives/user";
import {DRect} from "../../../primitives/drawable-rect";
import {Rect, RectConstructor} from "../../../primitives/rect";
import {interfaceActions} from "../../../../state/interface/interface.actions";


export class ProfileImageDrawable extends PixiObject {
  __debug = false;

  fileService: FilesService;

  profileImage: ImageDrawable;
  profileImagePlaceholder: Graphics;
  profileImageHolder: Container;
  blueprintContext: BlueprintContext;
  isMe: boolean;
  subscriptions: Subscription[] = []

  constructor(config: {
    blueprintContext: BlueprintContext;
    width: number,
    isMe: boolean
  }) {
    super({ id: "profile-image-drawable" });
    this.blueprintContext = config.blueprintContext;
    this.width = config.width;
    this.isMe = config.isMe;
    this.profileImageHolder = new Container();
    this.sprite.addChild(this.profileImageHolder);
    this.createProfileImagePlaceholder()
    this.fileService = config.blueprintContext.networkServices.fileService
    this.subscriptions.push(config.blueprintContext.stateServices.store.select(
            selectUserById(config.blueprintContext.entity.ownerId)
      ).subscribe(async user => {
        if (!user) return
        if (this.profileImage) {
          this.profileImage.destroy()
        }
        this.profileImage = new ImageDrawable({
          fitInSquareSize: config.width,
          fileId: user.profile_image_file_id,
          blueprintContext: config.blueprintContext,
          borderRadius: 100
        })
        this.profileImage.touchPrimitive.showPointerCursor = true
        this.profileImage.sprite.x = 0;
        this.profileImage.sprite.y = 0;
        await this.profileImage.createOrUpdate({})
        this.addChild(this.profileImage)
        this.profileImagePlaceholder.destroy()
    }))
    this.setupInteractions()
  }

  createProfileImagePlaceholder() {
      if (this.profileImagePlaceholder) {
        this.profileImagePlaceholder.destroy();
      }
      this.profileImagePlaceholder = new Graphics({});
      const rect = new DRect({
        left: 0,
        top: 0,
        right: this.width,
        bottom: this.width,
        roundness: 5,
        colour: this.niceColourMaker(),
      });
      rect.render(this.profileImagePlaceholder);
      this.profileImageHolder.addChild(this.profileImagePlaceholder);
  }

  setupInteractions() {
    this.touchPrimitive.onPressed( (pt) => {
      this.sprite.alpha = 0.5;
      this.requestRender()
      return true; // Stop propagation
    });
    this.touchPrimitive.onReleased( (pt) => {
      this.sprite.alpha = 1;
      this.requestRender()
      this.blueprintContext.stateServices.store.dispatch(interfaceActions.openContextMenu())
      this.blueprintContext.stateServices.router.navigate(
          [{outlets: {'context-menu': "context-profile"}}],
          {
            queryParams: {
              userId: this.blueprintContext.entity.ownerId,
              posX: pt.pos.x - 150,
              posY: pt.pos.y
            },
            queryParamsHandling: 'merge' // optional but common
          })
      return true; // Stop propagation
    });
  }

  niceColourMaker() {
    const r = 0.1 + (Math.random() * 0.05 - 0.02);
    const g = 0.1 + (Math.random() * 0.05 - 0.02);
    const b = 0.1 + (Math.random() * 0.05 - 0.02);
    return [r, g, b, 1];
  }

}
